import { SquareImageContainer, FluidImage } from '@vp/swan';
import React__default from 'react';

var buildSrcSet = function buildSrcSet(baseUrl, width) {
  return [1, 2, 3].map(function (dpr) {
    return "".concat(baseUrl, "&width=").concat(dpr * width, " ").concat(dpr, "x");
  }).join(', ');
};
var getDefaultView = function getDefaultView(tenantId, culture, productKey, productVersion, optionSelections, requestor, previewInstructionsUri, width) {
  var qs = "productVersion=".concat(productVersion, "&optionSelections=").concat(encodeURIComponent(JSON.stringify(optionSelections)), "&purpose=design.studio.review&requestor=").concat(requestor, "&previewInstructionsUri=").concat(previewInstructionsUri);
  var baseUrl = "https://purcs.design.vpsvc.com/api/v1/".concat(tenantId, "/").concat(culture, "/product/").concat(productKey, "/defaultViewImage?").concat(qs);
  return {
    src: "".concat(baseUrl, "&width=").concat(width),
    srcSet: buildSrcSet(baseUrl, width)
  };
};
var PurcsPreview = function PurcsPreview(_ref) {
  var coreProductId = _ref.coreProductId,
    coreProductVersion = _ref.coreProductVersion,
    renderingUrl = _ref.renderingUrl,
    optionSelections = _ref.optionSelections,
    _ref$requestor = _ref.requestor,
    requestor = _ref$requestor === void 0 ? 'omnisearch' : _ref$requestor,
    tenantId = _ref.tenantId,
    locale = _ref.locale,
    width = _ref.width;
  var preview = getDefaultView(tenantId, locale, coreProductId, coreProductVersion, optionSelections, requestor, renderingUrl, width);
  return /*#__PURE__*/React__default.createElement(SquareImageContainer, {
    style: {
      width: width
    }
  }, /*#__PURE__*/React__default.createElement(FluidImage, {
    src: preview.src,
    alt: "",
    srcSet: preview.srcSet,
    loading: "lazy"
  }));
};

export { PurcsPreview };
//# sourceMappingURL=CustomerWorkPreview.js.map
